import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TAllCropsData, TCommGroup, TGraphReport, TGraphTable, TMarkets } from "../types/daily-price/daily-price";

type selectedData = {
    cropId: number;
    state: string;
    district: string;
    marketId: number;
}

type TInitialState = {
    search: string;
    selectedCropId: selectedData;
    openSelected: boolean;
    toggleChartTable: 'chart' | 'table';
    marketOverview: TMarkets[];
    states: number[];
    districts: number[];
    markets: string[];
    commodityGroup: TCommGroup[];
    allCropsDetails: TAllCropsData[];
    allDataLoading: boolean;
    filteredCropsDetails: TAllCropsData[];
    selectedMarkets: number[];
    selectedState: number[];
    selectedDistrict: number[];
    selectedCommGroup: number[];
    graphTableData: TGraphTable | null;
};

const initialState: TInitialState = {
    search: "",
    openSelected: false,
    toggleChartTable: 'chart',
    marketOverview: [],
    states: [],
    districts: [],
    markets: [],
    commodityGroup: [],
    allCropsDetails: [],
    filteredCropsDetails: [],
    selectedMarkets: [],
    allDataLoading: false,
    selectedState: [],
    selectedDistrict: [],
    selectedCommGroup: [],
    graphTableData: null,
    selectedCropId: {
        cropId: 0,
        state: "",
        district: "",
        marketId: 0
    }
};

export const dailyPrice = createSlice({
    name: "dailyPrice",
    initialState: initialState,
    reducers: {
        resetDailyPriceDetails: (state) => {
            return {
                ...initialState,
            };
        },

        setSearch: (state, action: PayloadAction<string>) => {
            state.search = action.payload
        },
        setSelectedCropId: (state, action: PayloadAction<selectedData>) => {
            state.selectedCropId = action.payload
        },
        setOpenSelected: (state, action: PayloadAction<boolean>) => {
            state.openSelected = action.payload
        },
        setToggleChartTable: (state, action: PayloadAction<'chart' | 'table'>) => {
            state.toggleChartTable = action.payload
        },
        setMarketOverview: (state, action: PayloadAction<TMarkets[]>) => {
            state.marketOverview = action.payload
        },
        setStates: (state, action: PayloadAction<number[]>) => {
            state.states = action.payload
        },
        setDistricts: (state, action: PayloadAction<number[]>) => {
            state.districts = action.payload
        },
        setCommodityGroup: (state, action: PayloadAction<TCommGroup[]>) => {
            state.commodityGroup = action.payload
        },
        setAllCropsDetails: (state, action: PayloadAction<TAllCropsData[]>) => {
            state.allCropsDetails = action.payload
        },
        setFilteredCropsDetails: (state, action: PayloadAction<TAllCropsData[]>) => {
            state.filteredCropsDetails = action.payload
        },
        setSelectedMarkets: (state, action: PayloadAction<number[]>) => {
            state.selectedMarkets = action.payload
        },
        setSelectedState: (state, action: PayloadAction<number[]>) => {
            state.selectedState = action.payload
        },
        setSelectedDistrict: (state, action: PayloadAction<number[]>) => {
            state.selectedDistrict = action.payload
        },
        setSelectedCommGroup: (state, action: PayloadAction<number[]>) => {
            state.selectedCommGroup = action.payload
        },
        setGraphTableData: (state, action: PayloadAction<TGraphTable | null>) => {
            state.graphTableData = action.payload
        },
        setAllDataLoading: (state, action: PayloadAction<boolean>) => {
            state.allDataLoading = action.payload
        }
    },
});

export const {
    setSearch,
    setSelectedCropId,
    setOpenSelected,
    setToggleChartTable,
    setMarketOverview,
    setStates,
    setDistricts,
    setCommodityGroup,
    setAllCropsDetails,
    setSelectedMarkets,
    setSelectedState,
    setSelectedDistrict,
    setSelectedCommGroup,
    setGraphTableData,
    setFilteredCropsDetails,
    setAllDataLoading
} = dailyPrice.actions;
export default dailyPrice.reducer;
